import {Injectable} from "@angular/core";
import {UserManagementService} from "../../user-managment/user-management.service";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {filter, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {AddActivity} from "../actions";
import {
  GlobalEventDispatcherService
} from "../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {Router} from "@angular/router";
import * as activityActions from "../actions/activities.action";
import {ActivityAction} from "../../activities/activity";
import * as websiteActions from "../actions/website.action";
import * as userActions from "../actions/user.action";
import * as userLocalStorageActions from "../actions/user-local-storage.action";
import {SwitchWorkspace} from "../actions/workspace-switcher.action";
import * as workspaceActions from "../actions/workspace.action";
import * as fromStore from "../../store";

@Injectable()
export class WorkspaceSwitcherEffects {

  loadWorkspaceSwitcherActivity$ = createEffect(() => this._actions$.pipe(
    ofType(activityActions.ADD_ACTIVITY),
    filter((action: AddActivity): boolean => action.payload.action === ActivityAction.WORKSPACE_SWITCH && !!localStorage.getItem('dbSwitchWorkspace')),
    switchMap((action: AddActivity) => {
      setTimeout(() => {
        localStorage.removeItem('dbSwitchWorkspace');
      }, 2000);
      this._router.navigate(['/websites']);
      return [
        new workspaceActions.SetWorkspaceIdEntities({
          ownerWorkspaceId: action.payload.meta.owned_workspace_id,
          currentWorkspaceId: action.payload.meta.current_workspace_id,
          currentWorkspaceRoleId: action.payload.meta.role_id,
          globalEventDispatcherService: this._globalEventDispatcherService
        }),
        new userActions.LoadUser(),
        new userActions.LoadUserSubscription(),
        new userActions.LoadUserAvailableSubscriptions(),
        new userLocalStorageActions.LoadUserLocalStorage(),
        new websiteActions.ClearWebsites(),
        new websiteActions.LoadWebsites(),
        new SwitchWorkspace({switching: false, workspaceName: '', redirect: true}),
      ];
    })
  ));
  private currentWorkspaceId: number;
  private ownerWorkspaceId: any;

  constructor(
    private _store: Store<DbStoreState>,
    private _globalEventDispatcherService: GlobalEventDispatcherService,
    private _router: Router,
    private _actions$: Actions,
    private _userManagementService: UserManagementService
  ) {
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe(workspaceIdEntities => {
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });
  }
}
